module.exports = __webpack_public_path__ + "static/media/8.0f64e893.svg";